/**
 * rb-i18n.js — translation lookup, color schemes, locale date formatting.
 *
 * Pure leaf module. The controller calls RbI18n.setStrings() once at init with
 * the @json-injected translation table; every other module reads RbI18n.t().
 *
 * globalThis.RbI18n
 */
(function () {
    'use strict';

    var _strings = {};
    var LOCALE = (globalThis.__LOCALE || 'en').toString();

    /* 10 color schemes. `text`/`muted` are constant (dark ink on white paper);
       `accent`/`heading`/`subtle`/`border` carry the scheme identity. */
    var SCHEMES = {
        blue:     { accent: '#2563eb', heading: '#1e3a5f', subtle: '#eff6ff', border: '#bfdbfe', text: '#1a1a2e', muted: '#5b6472' },
        navy:     { accent: '#1e40af', heading: '#172554', subtle: '#eff6ff', border: '#93c5fd', text: '#1a1a2e', muted: '#5b6472' },
        teal:     { accent: '#0d9488', heading: '#134e4a', subtle: '#f0fdfa', border: '#99f6e4', text: '#1a1a2e', muted: '#5b6472' },
        green:    { accent: '#047857', heading: '#14532d', subtle: '#ecfdf5', border: '#a7f3d0', text: '#1a1a2e', muted: '#5b6472' },
        purple:   { accent: '#7c3aed', heading: '#3b0764', subtle: '#faf5ff', border: '#c4b5fd', text: '#1a1a2e', muted: '#5b6472' },
        burgundy: { accent: '#9f1239', heading: '#4c0519', subtle: '#fff1f2', border: '#fda4af', text: '#1a1a2e', muted: '#5b6472' },
        red:      { accent: '#dc2626', heading: '#7f1d1d', subtle: '#fef2f2', border: '#fecaca', text: '#1a1a2e', muted: '#5b6472' },
        orange:   { accent: '#ea580c', heading: '#7c2d12', subtle: '#fff7ed', border: '#fed7aa', text: '#1a1a2e', muted: '#5b6472' },
        slate:    { accent: '#475569', heading: '#1e293b', subtle: '#f8fafc', border: '#cbd5e1', text: '#1a1a2e', muted: '#5b6472' },
        charcoal: { accent: '#1f2937', heading: '#111827', subtle: '#f9fafb', border: '#d1d5db', text: '#1a1a2e', muted: '#5b6472' }
    };
    var SCHEME_ORDER = ['blue', 'navy', 'teal', 'green', 'purple', 'burgundy', 'red', 'orange', 'slate', 'charcoal'];

    function setStrings(obj) {
        _strings = obj && typeof obj === 'object' ? obj : {};
    }

    /* Translate a key; optional :placeholder substitution. Falls back to the
       key itself so a missing string is visible rather than blank. */
    function t(key, vars) {
        var s = _strings[key];
        if (s === undefined || s === null) return key;
        s = String(s);
        if (vars) {
            Object.keys(vars).forEach(function (k) {
                s = s.split(':' + k).join(String(vars[k]));
            });
        }
        return s;
    }

    function getScheme(id) {
        return SCHEMES[id] || SCHEMES.blue;
    }

    /* Labels printed ON the resume (headings, "Present", personal details) in the
       language the resume is written in. A Russian page can build an English
       resume; before this its headings stayed Russian. Falls back to the page
       strings when that language has no table. */
    var _docLangs = (globalThis.__rbDocLabels && typeof globalThis.__rbDocLabels === 'object') ? globalThis.__rbDocLabels : {};
    function docLang(model) {
        var l = model && model.meta && model.meta.lang;
        return (l && _docLangs[l]) ? l : LOCALE;
    }
    function docT(key, model, vars) {
        var table = _docLangs[docLang(model)];
        var s = table && table[key] != null ? String(table[key]) : null;
        if (s === null) return t(key, vars);
        if (vars) Object.keys(vars).forEach(function (k) { s = s.split(':' + k).join(String(vars[k])); });
        return s;
    }
    function docLangs() { return Object.keys(_docLangs); }

    /* Format a YYYY-MM (or YYYY) value per a region date_format token.
       Tokens: MM/YYYY, MM.YYYY, YYYY.MM, YYYY-MM. Unknown input returned as-is. */
    function formatDate(value, fmt) {
        if (!value) return '';
        var m = String(value).match(/^(\d{4})(?:-(\d{1,2}))?/);
        if (!m) return String(value);
        var year = m[1];
        var month = m[2] ? ('0' + m[2]).slice(-2) : '';
        if (!month) return year;
        fmt = fmt || 'MM/YYYY';
        switch (fmt) {
            case 'MM.YYYY': return month + '.' + year;
            case 'YYYY.MM': return year + '.' + month;
            case 'YYYY-MM': return year + '-' + month;
            default:        return month + '/' + year;
        }
    }

    /* A date RANGE, honoring an open ("Present") end. */
    function dateRange(start, end, current, fmt, presentLabel) {
        var a = formatDate(start, fmt);
        var b = current ? (presentLabel || 'Present') : formatDate(end, fmt);
        if (a && b) return a + ' — ' + b;
        return a || b || '';
    }

    globalThis.RbI18n = {
        LOCALE: LOCALE,
        SCHEMES: SCHEMES,
        SCHEME_ORDER: SCHEME_ORDER,
        setStrings: setStrings,
        t: t,
        docT: docT,
        docLang: docLang,
        docLangs: docLangs,
        getScheme: getScheme,
        formatDate: formatDate,
        dateRange: dateRange
    };
})();
